import { RequiredTranslationsTemplate } from '.'

const hr: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Croatian',
  },
  home: {
    title: 'OPOZIV PROIZVODA - ROCKRIDER XC500S',
    description:
      'Hvala Vam na kupnji brdskog bicikla (MTB) ROCKRIDER XC500S. Identificirali smo potencijalni nedostatak na prednjoj vilici. Samo neki bicikli iz serije su defektni. Molimo vas da unesete 30 znamenki serijskog broja Vašeg bicikla kako biste utvrdili da li je vaš bicikl zahvaćen ovim opozivom: ',
    form: {
      title: 'Molimo unesite sljedeće informacije:',
      fields: {
        serialNumber: 'Serijski broj bicikla',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Ime',
        lastName: 'Prezime',
        email: 'E-mail',
        phone: 'Broj telefona',
        country: 'Zemlja',
        submit: 'Za potvrdu',
        choose: 'Válasszon',
      },
      errors: {
        requiredField: 'Ovo polje je obavezno',
        unknownSerialNumber: 'Nepoznat serijski broj',
        provide6Numbers: 'Pažnja, potrebno je 6 znamenki',
      },
      confirmations: {
        good: {
          title: 'Vaš bicikl nije pogođen',
          p1: 'Vaš bicikl nije zahvaćen ovim opozivom. Možete nastaviti uživati u vožnji Vašim biciklom.',
          p2: 'Ispričavamo se za eventualne neugodnosti.',
          p3: 'Srdačno,',
          p4: 'Vaš Decathlon tim',
        },
        defective: {
          title: 'Vaš bicikl je nažalost zahvaćen ovim opozivom',
          p1: 'Molimo Vas da odmah prestanete koristiti bicikl i da kontaktirate najbližu Decathlon trgovinu kako biste zamijenili vilicu.',
          p2: 'Molimo Vas da imate na umu kako možda nećete moći koristiti Vaš bicikl nekoliko dana tijekom popravka. Budite uvjereni da ćemo učiniti sve u našoj mogućnosti da taj period bude što kraći. Savjetujemo vam da se izravno obratite servisu Decathlon trgovine koju ste odabrali kako bi Vam dali procjenu vremena popravka.',
          p3: 'Ovdje možete pronaći najbliži Decathlon servis:',
          decathlonLocatorLink: 'https://www.decathlon.hr/content/35-trgovine',
          p4: 'U nastavku se nalazi “Obavijest o povratu za kupca” koju je potrebno predočiti serviseru prilikom zaprimanja u servis:',
          p5: 'Za više informacija molimo Vas da kontaktirate naš specijalizirani pozivni centar za ovaj opoziv na 0 805 38 38 49, besplatno iz Francuske (od ponedjeljka do petka od 9:00 do 19:00), ili putem e-maila na rappel.decathlon@fandi.fr.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Kako pronaći serijski broj bicikla',
      description:
        '30-znamenkasti broj otisnut je na donjem dijelu okvira bicikla, ispod srednjeg pogona i poluga pedala. Pogledajte sliku ispod.',
    },
  },
}

export default hr
